import { defineHierarchyChart } from '@rdrive/helper-chart-config';
import { ITEMS_CHART, LOCATIONS, DRAWINGS, STATUS_LEVEL } from './itemsHierarchy.js';

// Item breakdown by drawing set -> drawing -> location -> status, for
// @rdrive/plugin-chart-stacked-bar's StackedHorizontalBarChart. Since IA_ABSORPTION_PLAN Phase 5
// steps 5.2–5.4 a level table on `defineHierarchyChart` (@rdrive/helper-chart-config) — the
// generated queries equal the old hand-written ones (tooling/parity/hierarchy-chart/), and every
// filter value goes through escapeSql (rule 6). Instantiated on the Drawings and Teams (overview)
// pages, so `chartName` must be unique per instance.
//
// A drawing-set bar's id is the set's TITLE; its filter reads the set id the row carries as
// parentId. Scoping: the drill scope ('andIdIn', ./itemsHierarchy.js) keeps a status click inside
// the drawing set / drawing / location the user navigated into.

export function useDrawingCategoryChart({ chartName, filterContext, conn }) {
  return defineHierarchyChart({
    chartName,
    filterContext,
    conn,
    ...ITEMS_CHART,
    defaults: { value: 'window' },
    levels: [
      {
        level: 'drawingsets', titleKey: 'drawingSets',
        id: 'd.drawingSetTitle', parentId: 'd.drawingSetId', title: 'd.drawingSetTitle',
        joins: [LOCATIONS, DRAWINGS], partitionBy: 'd.drawingSetTitle, s.title, s.color',
        filter: { joins: [LOCATIONS, DRAWINGS], where: [['d.drawingSetId', 'parentId']] },
      },
      {
        level: 'drawings', titleKey: 'drawings',
        id: 'l.drawingId', title: 'l.drawingTitle', joins: [LOCATIONS],
        filter: { joins: [LOCATIONS], where: [['l.drawingId', 'id']] },
      },
      {
        level: 'locations', titleKey: 'locations',
        id: 'l.id', title: 'l.title', joins: [LOCATIONS],
        filter: { where: [['i.locationId', 'id']] },
      },
      STATUS_LEVEL,
    ],
  });
}
